import React, { useEffect, useState } from "react";
import { ViewToggle } from "./ViewToggle";
import { Input } from "@shared/ui/input";
import { IconButton } from "@shared/components/IconButton";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { useDebounce } from "@shared/hooks/useDebounce";
import { useValidationContext } from "../../context";
import { useRoutesList } from "../../hooks";
import { mapToLabelValue } from "@features/mx/device-management/utils";
import MultiSelectDropdown from "@shared/components/MultiSelectDropdown";
import { useSearchParams } from "react-router-dom";
import { Button } from "@shared/ui/button";

interface ListViewActionsProps {
  onExportClick?: () => void;
  onSearch?: (debouncedSearch: string) => void;
  onRouteChange?: (selectedPremises: string[]) => void;
  onAutoComplete?: () => void;
}

function ListViewActions({
  onExportClick = () => {},
  onSearch = () => {},
  onRouteChange = () => {},
  onAutoComplete = () => {},
}: ListViewActionsProps) {
  const [search, setSearch] = useState("");
  const [value, setValue] = useState<any>([]); // array of premises
  const debounced = useDebounce(search, 500);
  const { cycleId } = useValidationContext();
  const { data: routesList } = useRoutesList(cycleId);
  const routes = mapToLabelValue(routesList, "routeName", "premises"); // route.value = string[]
  const [searchParams] = useSearchParams();
    const tab = searchParams.get("tab");


  // 🔁 Trigger search debounce effect
  useEffect(() => {
    onSearch(debounced);
  }, [debounced]);

  // 🔁 Trigger on route select
  useEffect(() => {
    onRouteChange(value);
  }, [value]);

  return (
    <div className="flex flex-col gap-2">
      <div className="ml-auto">
        <ViewToggle />
      </div>
      <div className="flex justify-between">
        <Input
          placeholder="Search resource id"
          onChange={(e) => setSearch(e.target.value)}
          className="w-1/3"
        />
        <span className="flex w-[40%] items-center gap-2">
          {(tab === "exemptions" || tab === "missing-readings") && (
            <Button
              size="sm"
              onClick={onAutoComplete}
              tooltip="All the readings will be estimated based on the priority set for the estimation rules."
            >
              Estimate
            </Button>
          )}          <MultiSelectDropdown
            options={routes}
            placeholder="Select Route"
            className="p-0 min-w-[30%] form-input"
            onChange={(value) => {
              setValue(value);
            }}
          />
          <IconButton
            label="Export"
            icon="FileUp"
            variant="secondary"
            onClick={onExportClick}
          />
        </span>
      </div>
    </div>
  );
}

export default ListViewActions;
